import { CircularProgress, List, ListItem, ListItemText, TextField, Typography } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const TripSource = ({ setPlace, setCity, setSelectedPlace, selectedPlace, label }) => {
  const { mashawiritoken } = useSelector((state) => state.auth);

  const [autoComplete, setAutoComplete] = useState('');
  const [resault, setResault] = useState([]);
  const [loading, setLoading] = useState(false);
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  const handleInputChange = (e) => {
    selectedPlace !== '' ? setSelectedPlace(e.target.value) : setAutoComplete(e.target.value);
  };

  const handleListItemClick = (item) => {
    setSelectedPlace(item.description);
    setAutoComplete('');
    setResault([]);

    axios
      .get(`${process.env.REACT_APP_API_URL}place_details?place_id=${item.place_id}`, {
        headers: {
          Authorization: `Bearer ${mashawiritoken}`,
        },
      })
      .then((res) => {
        console.log(res);
        setPlace(`${res.data.location.lat},${res.data.location.lng}`);
        setCity(res.data.city_name);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    setLoading(true);
    const search = () => {
      axios
        .post(`${process.env.REACT_APP_API_URL}place_auto_complete`, { q: autoComplete })
        .then((res) => {
          setLoading(false);
          console.log(res);
          if(res.data.placess){
          setResault(res.data.placess);
        }
          else{
            setResault([{'description' : 'not found'}])
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    };

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    if (autoComplete) {
      const newDebounceTimeout = setTimeout(() => {
        search();
      }, 3000);
      setDebounceTimeout(newDebounceTimeout);
    }

    return () => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
    };
  }, [autoComplete]);

  return (
    <>
      <TextField
        fullWidth
        // sx={{ width: '50%  ' }}
        name="source"
        label={label}
        value={selectedPlace !== '' ? selectedPlace : autoComplete}
        onChange={handleInputChange}
      />
      {autoComplete !== '' ? (
        loading ? (
          <List sx={{ width: '50%', bgcolor: 'background.paper', boxShadow: '0px 0px 19px -5px rgba(0,0,0,0.75)' }}>
            <CircularProgress sx={{ color: '#000' }} />
          </List>
        ) : resault.length && !loading ? (
          <List sx={{ width: '50%', bgcolor: 'Background.paper', boxShadow: '0px 0px 19px -5px rgba(0,0,0,0.75)' }}>
            {resault.map((item, index) => (
              <ListItem
                key={index}
                sx={{ '&:hover': { backgroundColor: '#eeeeee', cursor: 'pointer' } }}
                onClick={() => handleListItemClick(item)}
              >
                <ListItemText primary={item.description} />
              </ListItem>
            ))}
          </List>
        ) : (
        ''
        )
      ) : (
        ''
      )}
    </>
  );
};

export default TripSource;
